// import { Injectable, Inject } from "@angular/core";
// import {
//     HttpRequest,
//     HttpHandler,
//     HttpEvent,
//     HttpInterceptor,
//     HttpErrorResponse,
// } from "@angular/common/http";
// import { AuthenticationService } from "../authentication/authentication.service";
// import { Observable, throwError, BehaviorSubject } from "rxjs";
// import { catchError, filter, take, switchMap } from "rxjs/operators";
// import { environment } from "../../../environments/environment";
// import {WINDOW} from '../window/window.service';
// import {AnalyticsDispatcherService} from '../analytics/analytics-dispatcher.service';

// @Injectable({
//     providedIn: "root",
// })
// export class TokenInterceptor implements HttpInterceptor {
//     constructor(
//         public auth: AuthenticationService,
//         @Inject(WINDOW) private window: Window,
//         private analyticsDispatcher: AnalyticsDispatcherService,
//     ) { }
//     private isRefreshing = false;
//     private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
//     private isLoggedin = false;
//     private LoggedinSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    
//     private getParams (url: string) {
//         let params = {};
        
//         new URLSearchParams(url).forEach(function (val, key) {
//             if (params[key] !== undefined) {
//                 if (!Array.isArray(params[key])) {
//                     params[key] = [params[key]];
//                 }
//                 params[key].push(val);
//             } else {
//                 params[key] = val;
//             }
//         });
//         if(Object.keys(params).length > 0){
//             return params;
//         }
//         return null;
//     }

//     intercept(
//         request: HttpRequest<any>,
//         next: HttpHandler
//     ): Observable<HttpEvent<any>> {
        
        
//        if (this.auth.getUserToken()) {
//             request = this.addToken(request, this.auth.getUserToken());
//             this.handle401Error(request, next)
//         }
//         return next.handle(request).pipe(
//             catchError((error) => {
//                 if (
//                     error instanceof HttpErrorResponse &&
//                     [400, 401].includes(error.status) &&
//                     (request.url.indexOf(
//                         environment.apiUrl.services.login
//                     ) > -1)
//                 ) {
                    
//                     const user = JSON.parse(localStorage.getItem('user')) as any;

//                     const eventParams = {
//                         event_name: 'web_login_failure',
//                         environment: environment.production ? 'production' : 'staging',
//                         user_id: user ? user.id : "",
//                         name: (user && user.profile) ? `${user.profile.first_name} ${user.profile.last_name}` : "",
//                         email: user ? user.email : "",  
//                     };

//                     this.analyticsDispatcher.notify('account_logout', eventParams);
                    
//                     localStorage.removeItem('user');
//                     localStorage.removeItem('token');
//                     localStorage.removeItem('x7uER!n');
//                     localStorage.removeItem('x71uER!n');
//                     if (
//                         request.url.indexOf(
//                             environment.apiUrl.services.login
//                         ) > -1 || 
//                         request.url.indexOf(
//                             environment.apiUrl.services.refreshToken
//                         ) > -1
//                     ) {
//                         return throwError(error);
//                     }else{
//                         this.window.location.reload();
//                         return null;
//                     }
//                 } else if (
//                     error instanceof HttpErrorResponse &&
//                     error.status === 401 &&
//                     request.url.indexOf(
//                         environment.apiUrl.services.refreshToken
//                     ) > -1
//                 ) {
//                     return this.login(request, next);
//                 }

//                 if (
//                     error instanceof HttpErrorResponse &&
//                     error.status === 401
//                 ) {
//                     return this.handle401Error(request, next);
//                 } else {
//                     return throwError(error);
//                 }
//             })
//         );
//     }

//     private addToken(request: HttpRequest<any>, token: string) {
//         if (request.url.indexOf('jsonip.com')){
//             return request.clone();
//         }
//         return request.clone({
//             setHeaders: {
//                 Authorization: `Bearer ${token}`,
//             },
//         });
//     }

//     private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
//         if (!this.isRefreshing) {
//             this.isRefreshing = true;
//             this.refreshTokenSubject.next(null);

//             return this.auth.refreshToken().pipe(
//                 switchMap((res: any) => {
//                     this.isRefreshing = false;
//                     this.refreshTokenSubject.next(res["token"]);
//                     return next.handle(this.addToken(request, res["token"]));
//                 })
//             );
//         } else {
//             return this.refreshTokenSubject.pipe(
//                 filter((token) => token != null),
//                 take(1),
//                 switchMap((jwt) => {
//                     return next.handle(this.addToken(request, jwt));
//                 })
//             );
//         }
//     }

//     private login(request: HttpRequest<any>, next: HttpHandler) {
//         if (!this.isLoggedin) {
//             this.isLoggedin = true;
//             this.LoggedinSubject.next(null);

//             return this.auth.login({ email: atob(localStorage.getItem('x7uER!n')), password: atob(localStorage.getItem('x71uER!n')) }).pipe(
//                 switchMap((res: any) => {
//                     this.isLoggedin = false;
//                     this.LoggedinSubject.next(res["token"]);
//                     return next.handle(this.addToken(request, res["token"]));
//                 })
//             );
//         } else {
//             return this.LoggedinSubject.pipe(
//                 filter((token) => token != null),
//                 take(1),
//                 switchMap((jwt) => {
//                     return next.handle(this.addToken(request, jwt));
//                 })
//             );
//         }        
//     }
// }


import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { AuthenticationService } from "../authentication/authentication.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable, of, throwError, Subscription } from 'rxjs';
import { switchMap, concatMap, delay, retryWhen, filter, take, catchError} from "rxjs/operators";
export const retryCount = 3;
export const retryWaitMilliSeconds = 1000;

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private refreshTokenInProgress = false;
    // Refresh Token Subject tracks the current token, or is null if no token is currently
    // available (e.g. refresh pending).
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
        null
    );
    private isRefreshing = false;
    constructor(private auth: AuthenticationService) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            retryWhen(error => error.pipe(
                concatMap((error, count) => {
                    if (count <= retryCount && error.status == 401) {
                        return this.handle401Error(request, next);
                    }
                    return throwError(error);
                }),
                delay(retryWaitMilliSeconds),
                catchError(error => {
                    return throwError(error);
                })
            ))
        )
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return this.auth.refreshToken().pipe(
                switchMap((res: any) => {
                    this.isRefreshing = false;
                    this.refreshTokenSubject.next(res["token"]);
                    return next.handle(this.addToken(request, res["token"]));
                })
            );
        } else {
            return this.refreshTokenSubject.pipe(
                filter((token) => token != null),
                take(1),
                switchMap((jwt) => {
                    return next.handle(this.addToken(request, jwt));
                }),
                catchError(error => {
                    return null;
                })
            );
        }
    }

    private addToken(request: HttpRequest<any>, token: string) {
        if (request.url.indexOf('jsonip.com')){
            return request.clone();
        }
        return request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
            },
        });
    }
}
